import numernal from 'numeral'
import { I18n } from 'react-redux-i18n'

export const priceFormat = (value) =>
  numernal(value).format(I18n.t('currency.format'))
